import { useState } from "react";

import { TyreModal, TyresDashboardFilters, TyresDashboardTable } from "modules/TyresDashboard/components";

import type { Tyre } from "models";

export const TyresDashboard = () => {
  const [selectedTyre, setSelectedTyre] = useState<Tyre | null | undefined>();

  return (
    <>
      <TyresDashboardFilters onOpenCreateModal={() => setSelectedTyre(null)} />
      <TyresDashboardTable onOpenEditModal={setSelectedTyre} />
      <TyreModal tyre={selectedTyre} onClose={() => setSelectedTyre(undefined)} />
    </>
  );
};
